import { useState } from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';

import { StyledTextField } from '../index.js';

interface OwnProps {
    helperText?: string;
    error?: boolean;
    fullWidth?: boolean;
}

const StyledDatePicker: FC<Omit<DatePickerProps, 'renderInput'> & OwnProps> = ({
    helperText,
    format = 'MM/dd/yyyy',
    fullWidth,
    error,
    ...rest
}) => {
    const [open, setOpen] = useState(false);

    return (
        <DatePicker
            enableAccessibleFieldDOMStructure={false}
            open={open}
            slots={{
                textField: StyledTextField,
            }}
            slotProps={{
                textField: {
                    helperText,
                    error,
                    fullWidth,
                    onClick: () => setOpen(true),
                },
            }}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            format={format}
            {...rest}
        />
    );
};

export default StyledDatePicker;
